export default {
  title: 'Neue Marke',
  tabs: {
    general: 'Allgemein',
    branding: 'Branding',
    scripts: 'Skripte',
    tracking: 'Tracking',
    domain: 'Domain',
  },
  fields: {
    name: {
      label: 'Name',
      placeholder: 'Name der Marke',
    },
    slug: {
      label: 'Subdomain',
      placeholder: 'Subdomain der Marke',
      hint: 'Kleinbuchstaben, Zahlen und Bindestriche. Zusammen mit der Shop-Domain ergibt sie die Shop-Adresse.',
      preview: 'Shop-Adresse: {{url}}',
      availability: {
        taken: 'Eine andere Marke verwendet diese Subdomain auf dieser Shop-Domain bereits.',
        reserved: 'Diese Subdomain ist reserviert. Wählen Sie eine andere.',
        invalid_label:
          'Auf dieser Shop-Domain darf die Subdomain nur Kleinbuchstaben, Zahlen und Bindestriche enthalten, muss mit einem Buchstaben oder einer Zahl beginnen und enden und darf höchstens 63 Zeichen lang sein.',
        taken_elsewhere:
          'Eine Marke auf einer anderen Shop-Domain verwendet diese Subdomain bereits. Wählen Sie eine andere.',
        format: 'Verwenden Sie nur Buchstaben, Zahlen, Bindestriche und Unterstriche.',
        unavailable: 'Diese Subdomain ist nicht verfügbar. Wählen Sie eine andere.',
      },
    },
    shop_domain_id: {
      label: 'Shop-Domain',
      placeholder: 'Shop-Domain auswählen',
      move_warning: {
        title: 'Damit ändert sich die Shop-Adresse, die Kunden verwenden',
        description:
          'Nach dem Speichern ist der Shop unter {{url}} erreichbar. Bereits gedruckte oder geteilte QR-Codes, Flyer und Links mit der alten Adresse funktionieren dann nicht mehr.',
      },
    },
    lieferando_url: {
      label: 'Lieferando URL',
      placeholder: 'URL des Restaurants in Lieferando',
    },
    primary_color: {
      label: 'Primäre Farbe',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Bild',
    },
    companies: {
      label: 'Restaurants',
    },
    noscripts: {
      description: 'Code sofort nach dem Öffnen des Bodys einfügen',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Facebook Conversion Access Token',
    },
    google_analytics_id: {
      label: 'Google analytics ID',
    },
    google_ads_conversion_label_id: {
      label: 'Google ads conversion label',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Eigene Domain für den Online-Shop',
    },
  },
  buttons: {
    save: 'Speichern',
    close: 'Schließen',
    sync_from_lieferando: 'Sync von Lieferando',
  },
  toasts: {
    changes_saved_successfully: 'Die Änderungen wurden erfolgreich gespeichert!',
    failed_to_update_company_slug: 'Slug konnte nicht aktualisiert werden für {{name}}',
    failed_to_sync_lieferando: 'Details von Lieferando konnten nicht synchronisiert werden',
    successfully_synced_lieferando: 'Daten erfolgreich von Lieferando synchronisiert',
    failed_to_load_shop_domains: 'Shop-Domains konnten nicht geladen werden.',
  },
};
